import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "fillColor", "onRemove", "id", "isSelected", "text", "size", "hideRemoveButton", "href", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React__default, { forwardRef, useMemo } from 'react';
import TokenBase, { isTokenInteractive, defaultTokenSize } from './TokenBase.js';
import RemoveTokenButton from './_RemoveTokenButton.js';
import { parseToRgba, parseToHsla } from 'color2k';
import { useTheme } from '../ThemeProvider.js';
import TokenTextContainer from './_TokenTextContainer.js';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var tokenBorderWidthPx = 1;
var lightModeStyles = {
  '--lightness-threshold': '0.453',
  '--border-threshold': '0.96',
  '--border-alpha': 'max(0, min(calc((var(--perceived-lightness) - var(--border-threshold)) * 100), 1))',
  background: 'rgb(var(--label-r), var(--label-g), var(--label-b))',
  color: 'hsl(0, 0%, calc(var(--lightness-switch) * 100%))',
  borderWidth: tokenBorderWidthPx,
  borderStyle: 'solid',
  borderColor: 'hsla(var(--label-h),calc(var(--label-s) * 1%),calc((var(--label-l) - 25) * 1%),var(--border-alpha))'
};
var darkModeStyles = {
  '--lightness-threshold': '0.6',
  '--background-alpha': '0.18',
  '--border-alpha': '0.3',
  '--lighten-by': 'calc(((var(--lightness-threshold) - var(--perceived-lightness)) * 100) * var(--lightness-switch))',
  borderWidth: tokenBorderWidthPx,
  borderStyle: 'solid',
  background: 'rgba(var(--label-r), var(--label-g), var(--label-b), var(--background-alpha))',
  color: 'hsl(var(--label-h), calc(var(--label-s) * 1%), calc((var(--label-l) + var(--lighten-by)) * 1%))',
  borderColor: 'hsla(var(--label-h), calc(var(--label-s) * 1%),calc((var(--label-l) + var(--lighten-by)) * 1%),var(--border-alpha))'
};
var IssueLabelToken = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var as = props.as,
      _props$fillColor = props.fillColor,
      fillColor = _props$fillColor === void 0 ? '#999' : _props$fillColor,
      onRemove = props.onRemove,
      id = props.id,
      isSelected = props.isSelected,
      text = props.text,
      _props$size = props.size,
      size = _props$size === void 0 ? defaultTokenSize : _props$size,
      hideRemoveButton = props.hideRemoveButton,
      href = props.href,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded);

  var interactiveTokenProps = {
    as: as,
    href: href,
    onClick: onClick
  };

  var _useTheme = useTheme(),
      resolvedColorScheme = _useTheme.resolvedColorScheme;

  var hasMultipleActionTargets = isTokenInteractive(props) && Boolean(onRemove) && !hideRemoveButton;

  var onRemoveClick = function onRemoveClick(e) {
    e.stopPropagation();
    onRemove && onRemove();
  };

  var labelStyles = useMemo(function () {
    var _parseToRgba = parseToRgba(fillColor),
        _parseToRgba2 = _slicedToArray(_parseToRgba, 3),
        r = _parseToRgba2[0],
        g = _parseToRgba2[1],
        b = _parseToRgba2[2];

    var _parseToHsla = parseToHsla(fillColor),
        _parseToHsla2 = _slicedToArray(_parseToHsla, 3),
        h = _parseToHsla2[0],
        s = _parseToHsla2[1],
        l = _parseToHsla2[2];

    var isLightScheme = !(resolvedColorScheme !== null && resolvedColorScheme !== void 0 && resolvedColorScheme.startsWith('dark')); // fall back to light colors for unknown schemes
    // label hack taken from https://github.com/github/github/blob/master/app/assets/stylesheets/hacks/hx_primer-labels.scss#L43-L108
    // this logic should eventually live in primer/components. Also worthy of note is that the dotcom hack code will be moving to primer/css soon.

    return _objectSpread(_objectSpread(_objectSpread({
      '--label-r': String(r),
      '--label-g': String(g),
      '--label-b': String(b),
      '--label-h': String(Math.round(h)),
      '--label-s': String(Math.round(s * 100)),
      '--label-l': String(Math.round(l * 100)),
      '--perceived-lightness': 'calc(((var(--label-r) * 0.2126) + (var(--label-g) * 0.7152) + (var(--label-b) * 0.0722)) / 255)',
      '--lightness-switch': 'max(0, min(calc((var(--perceived-lightness) - var(--lightness-threshold)) * -1000), 1))',
      paddingRight: hideRemoveButton || !onRemove ? undefined : 0,
      position: 'relative'
    }, isLightScheme ? lightModeStyles : darkModeStyles), isSelected ? {
      background: isLightScheme ? 'hsl(var(--label-h), calc(var(--label-s) * 1%), calc((var(--label-l) - 5) * 1%))' : darkModeStyles.background,
      ':focus': {
        outline: 'none'
      },
      ':after': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        top: "-".concat(tokenBorderWidthPx * 2, "px"),
        right: "-".concat(tokenBorderWidthPx * 2, "px"),
        bottom: "-".concat(tokenBorderWidthPx * 2, "px"),
        left: "-".concat(tokenBorderWidthPx * 2, "px"),
        display: 'block',
        pointerEvents: 'none',
        boxShadow: "0 0 0 ".concat(tokenBorderWidthPx * 2, "px ").concat(isLightScheme ? 'rgb(var(--label-r), var(--label-g), var(--label-b))' : 'hsl(var(--label-h), calc(var(--label-s) * 1%), calc((var(--label-l) + var(--lighten-by)) * 1%))'),
        borderRadius: '999px'
      }
    } : {}), isTokenInteractive(props) ? {
      '&:hover': _objectSpread(_objectSpread({}, isLightScheme ? {
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(rgb(var(--label-r),var(--label-g),var(--label-b)), rgb(var(--label-r),var(--label-g),var(--label-b)))'
      } : {
        background: 'hsla(var(--label-h), calc(var(--label-s) * 1%), calc(calc(var(--label-l) + 10) * 1%), 0.3);'
      }), {}, {
        boxShadow: 'shadow.medium'
      })
    } : {});
  }, [fillColor, resolvedColorScheme, hideRemoveButton, onRemove, isSelected, props]);
  return /*#__PURE__*/React__default.createElement(TokenBase, _extends({
    onRemove: onRemove,
    id: id === null || id === void 0 ? void 0 : id.toString(),
    isSelected: isSelected,
    text: text,
    size: size,
    sx: labelStyles
  }, !hasMultipleActionTargets ? interactiveTokenProps : {}, rest, {
    ref: forwardedRef
  }), /*#__PURE__*/React__default.createElement(TokenTextContainer, hasMultipleActionTargets ? interactiveTokenProps : {}, text), !hideRemoveButton && onRemove ? /*#__PURE__*/React__default.createElement(RemoveTokenButton, {
    borderOffset: tokenBorderWidthPx,
    onClick: onRemoveClick,
    size: size,
    "aria-hidden": hasMultipleActionTargets ? 'true' : 'false',
    isParentInteractive: isTokenInteractive(props),
    sx: hasMultipleActionTargets ? {
      position: 'relative',
      zIndex: '1'
    } : {}
  }) : null);
});
IssueLabelToken.displayName = 'IssueLabelToken';
var IssueLabelToken$1 = IssueLabelToken;
export { IssueLabelToken$1 as default };